import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// const firebaseConfig = {
//   apiKey: "AIzaSyDJ07_Eo46dvzs9TnLRVnbyJPFE0qN9_fQ",
//   authDomain: "events-f5014.firebaseapp.com",
//   projectId: "events-f5014",
//   storageBucket: "events-f5014.appspot.com",
//   messagingSenderId: "463320775831",
//   appId: "1:463320775831:web:5bea6e93719994df937dd2",
//   measurementId: "G-JQC863V1M2"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAvKToud-_xI3i5qp2of33TlJc5HsqmRgc",
  authDomain: "tadiclan-database.firebaseapp.com",
  projectId: "tadiclan-database",
  storageBucket: "tadiclan-database.firebasestorage.app",
  messagingSenderId: "107479752077",
  appId: "1:107479752077:web:eb4608662b474704bbb1c4",
  measurementId: "G-MFKKBGQZNS"
};


const app = initializeApp(firebaseConfig);


const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const deleteAccountUrl = 'http://127.0.0.1:5001/tadiclan-database/us-central1/deleteAccount'

export { db, auth, storage, deleteAccountUrl };
